/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementController', MemberManagementController);

    MemberManagementController.$inject = ['DataUtils', 'MemberManagement', 'MemberManagementSearch', 'Principal', 'paginationConstants', 'pagingParams', 'ParseLinks', 'AlertService', '$state'];

    function MemberManagementController(DataUtils, MemberManagement, MemberManagementSearch, Principal, paginationConstants, pagingParams, ParseLinks, AlertService, $state) {

        var vm = this;

        vm.members = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentAccount = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.currentSearch = null;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.setVerified = setVerified;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.setSelect = setSelect;
        vm.setActive = setActive;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;

        if (vm.currentSearch == null) {
            vm.selectIsMember = vm.select === 'voll' || vm.select === 'probe' || vm.select === 'gast';
        } else {
            vm.selectIsMember = !vm.currentSearch.toLowerCase().startsWith("aus_");
        }

        loadAll();

        function setSelect(select) {
            vm.select = select;
            vm.transition();
        }

        function setActive (profile, activated) {
            profile.user.activated = activated;
            MemberManagement.update(profile, function () {
                loadAll();
                AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
            });
        }

        function setVerified (profile, isVerified) {
            profile.isVerified = isVerified;
            MemberManagement.update(profile, function () {
                loadAll();
                AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
            });
        }

        function loadAll () {
            if (pagingParams.search) {
                MemberManagementSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MemberManagement.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    select: pagingParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.members = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'user.id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });
    }
})();
